<template>
  <section
    class="brief-welcome brief__step uk-cover-container uk-flex uk-flex-middle"
  >
    <picture>
      <source srcset="@/assets/images/koniec.png" media="(min-width: 960px)" />
      <source
        srcset="@/assets/images/koniec@tab.png"
        media="(min-width: 640px)"
      />
      <source srcset="@/assets/images/koniec@mob.png" />
      <img
        alt="powitania tło"
        src="@/assets/images/koniec.png"
        data-uk-cover
        ref="backgroundImage"
      />
    </picture>
    <Fireworks ref="fireworks" />
    <div class="uk-container">
      <div class="brief-welcome__content">
        <h2 class="brief-welcome__header">dziękujemy za wypełnienie briefa</h2>
        <p class="brief-welcome__description">
          w ciągu 48h otrzymasz wiadomość z naszą ofertą
        </p>
        <span class="brief-welcome__hash"> #missioncomplete </span>
        <a href="/" class="button button--shadow"> powrót do solveit.pl </a>
      </div>
    </div>
  </section>
</template>
<script>
import Fireworks from '../global/Fireworks.vue';

export default {
  name: 'ThankYou',
  props: {
    isMobile: {
      type: Boolean,
      require: true,
    },
  },
  components: {
    Fireworks,
  },
  computed: {
    backgroundImage() {
      return this.isMobile ? 'koniec@mob.png' : 'koniec.png';
    },
  },
  methods: {
    fireworks() {
      this.$refs.fireworks.fireHandler();
    },
  },
  mounted() {
    this.$refs.backgroundImage.setAttribute(
      'style',
      // eslint-disable-next-line comma-dangle
      `height:${window.innerHeight}px; width:${window.innerWidth}px;`,
    );
  },
};
</script>
<style scoped lang="scss">
.brief-welcome {
  background-color: $purpleDim;
  color: $white;
  position: relative;
  min-height: 100vh;
  width: 100%;

  &__header {
    font-size: 1.75rem;
    font-weight: 900;
    margin-bottom: rem(40px);
    max-width: 13.5rem;

    @include media-min($sm) {
      max-width: 23rem;
    }

    @include media-min($lg) {
      font-size: 2.5rem;
      margin-bottom: rem(48px);
    }
  }

  &__description {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: rem(40px);
    max-width: 13.5rem;

    @include media-min($sm) {
      max-width: 21rem;;
    }
  }

  &__hash {
    font-size: 1.25rem;
    font-weight: 500;
    color: $teal;
    display: block;
    margin-bottom: rem(95px);
  }

  &__content {
    @include media-min($lg) {
      transform: translateX(rem(300px));
    }
  }

  .uk-container {
    position: relative;
    z-index: 10;
    width: 100%;
    max-width: rem(800px);
  }
}
</style>
